import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import SustainableDevelopment from "~/views/sustainable-development"

const getInitialProps: GetInitialPropsType = async ({ req, query: { ...query } }) => {
  const apiContext = await getApiContext(
    [
      { url: "/pressreleases/list" },
      { url: "/news/list" },
      { url: "/media/list" },
      { url: "/massmedia/list" },
      { url: "/ir/list" },
      { url: "/formwithcontacts/list", code: "sustainable-development" },
      { url: "/sustainable/page" },
      {
        url: "/sustainablecases/list",
        query: { items_per_page: 2, page_number: 1, ...query },
      },
      { url: "/programs/list" },
      { url: "/documents/elements", code: "socialreports" },
    ],
    req ? req.headers.host : location.host,
  )

  const slug = req?.url?.split("/")[1]
  const crumbs = generateCrumbs(req?.url)
  return { apiContext, crumbs, slug }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
SustainableDevelopment.getInitialProps = getInitialProps

export default SustainableDevelopment
